import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { DashboardSummaryDTO } from '@shared/types';

export function useDashboardSummary(month?: string) {
  return useQuery({
    queryKey: ['dashboard', 'summary', month],
    queryFn: async () => (await api.get<DashboardSummaryDTO>('/dashboard/summary', { params: { month } })).data,
  });
}
